import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { localize } from '@saviynt/common';
import { Box, Button, Loader, Typography } from '@saviynt/design-system';

import { getProgressBreakdownDetails } from '../../../../redux/certdetails/action';
import {
  CAMPAIGN_TYPES,
  CAMPAIGNTYPE_ENTITLEMENTOWNER,
} from '../../../../utils/constant';
import { getMessageKey } from '../../../../utils/utils';
import { BY_TYPE, DONE, TOTAL } from '../constants';
import {
  customEoSortByType,
  customSortByType,
  getIconKind,
  isEmptyObject,
} from '../utils';

import TypeLabel from './TypeLabel';

import './ViewByType.css';

function ViewByType() {
  const intl = useIntl();
  const dispatch = useDispatch();

  const { messages } = useSelector((state) => state?.user);
  const {
    core: { campaignType },
    global: { certKey },
    progressBreakdowndetails: { byTypeDetails, errorMessage, isLoading },
  } = useSelector((state) => state?.certifications?.details);

  const isEOCampaign =
    CAMPAIGN_TYPES[campaignType] === CAMPAIGNTYPE_ENTITLEMENTOWNER;

  const TYPE_TITLES = {
    Role:
      messages['Role_LABEL.ATTESTATIONS'] ||
      localize(intl, getMessageKey('Role_LABEL.ATTESTATIONS')),
    Account:
      messages['Account_LABEL.ATTESTATIONS'] ||
      localize(intl, getMessageKey('Account_LABEL.ATTESTATIONS')),
    User:
      messages['User_LABEL.ATTESTATIONS'] ||
      localize(intl, getMessageKey('User_LABEL.ATTESTATIONS')),
    Entitlement:
      messages['Ent_LABEL.ATTESTATIONS'] ||
      localize(intl, getMessageKey('Ent_LABEL.ATTESTATIONS')),
    ParentEnt:
      messages['Ent_LABEL.ATTESTATIONS'] ||
      localize(intl, getMessageKey('Ent_LABEL.ATTESTATIONS')),
    ChildEntitlement:
      messages['Ent2_LABEL.ATTESTATIONS'] ||
      localize(intl, getMessageKey('Ent2_LABEL.ATTESTATIONS')),
    allitems:
      messages.CERTS_EXPORT_WHAT_TO_EXPORT_ALL_ITEMS ||
      localize(intl, getMessageKey('CERTS_EXPORT_WHAT_TO_EXPORT_ALL_ITEMS')), //
    default:
      messages.CERTS_NOT_PROVIDED ||
      localize(intl, getMessageKey('CERTS_NOT_PROVIDED')),
  };

  useEffect(() => {
    if (certKey) {
      dispatch(getProgressBreakdownDetails(certKey, BY_TYPE));
    }
  }, [certKey]);

  const refreshProgressDataByType = () => {
    if (certKey) {
      dispatch(getProgressBreakdownDetails(certKey, BY_TYPE));
    }
  };

  const showErrorMessage = () => (
    <Box className='ViewByType-progressFailure'>
      <Typography kind='body2-bold' className='ViewByType-errorMessage'>
        {messages.CERTS_PROGRESS_TYPE_LOAD_ERROR ||
          localize(intl, getMessageKey('CERTS_PROGRESS_TYPE_LOAD_ERROR'))}
      </Typography>

      <Button
        type='button'
        kind='filled'
        size='medium'
        onClick={refreshProgressDataByType}>
        {messages['Refresh.ATTESTATIONS'] ||
          localize(intl, getMessageKey('Refresh.ATTESTATIONS'))}
      </Button>
    </Box>
  );

  return (
    <div className='ViewByType'>
      {isLoading ? (
        <Box className='ViewByType-loader'>
          <Loader kind='dots' format='inline' color='brand' size='small' />
        </Box>
      ) : (
        <>
          {errorMessage && showErrorMessage()}
          {byTypeDetails?.Summary && !isEmptyObject(byTypeDetails?.Summary)
            ? Object.entries(byTypeDetails.Summary)
                ?.sort(isEOCampaign ? customEoSortByType : customSortByType)
                .map(([key, value]) => (
                  <TypeLabel
                    key={key}
                    count={value[DONE]}
                    totalCount={value[TOTAL]}
                    iconKind={getIconKind(key)}
                    label={TYPE_TITLES[key]}
                    doneLabel={
                      messages.CERTS_DONE ||
                      localize(intl, getMessageKey('CERTS_DONE'))
                    }
                    ofLabel={
                      messages.CERTS_OF_LABEL ||
                      localize(intl, getMessageKey('CERTS_OF_LABEL'))
                    }
                  />
                ))
            : !errorMessage && showErrorMessage()}
        </>
      )}
    </div>
  );
}

export default ViewByType;
